import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { OPEN_PALETTE_EVENT } from '../../components/CommandPalette/CommandPalette'
import '../../components/ui/ui.scss'
import './NotFound.scss'

const NotFound = () => {
  const { pathname } = useLocation()

  return (
    <main className="ui-page nf">
      <div className="page-hero__orb orb-a" aria-hidden="true" />
      <div className="page-hero__orb orb-b" aria-hidden="true" />
      <div className="nf__inner ui-container">
        <h1 className="nf__code" data-text="404" aria-label="Error 404">404</h1>
        <div className="nf__term" role="presentation">
          <div className="nf__term-bar"><span /><span /><span /></div>
          <p><span className="nf__prompt">$</span> cd {pathname}</p>
          <p className="nf__err">bash: {pathname}: No such file or directory</p>
          <p><span className="nf__prompt">$</span> suggest --route<span className="nf__caret" /></p>
        </div>
        <p className="nf__lead">This page wandered off. Let&apos;s get you somewhere useful.</p>
        <div className="nf__actions">
          <Link className="ui-submit" to="/" data-magnetic><i className="fas fa-house" /> Back home</Link>
          <Link className="nf__btn" to="/services">View services</Link>
          <button type="button" className="nf__btn" onClick={() => window.dispatchEvent(new Event(OPEN_PALETTE_EVENT))}>
            <kbd>⌘K</kbd> Search
          </button>
        </div>
      </div>
    </main>
  )
}

export default NotFound
